webpackJsonp([0],{

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Index_vue_vue_type_template_id_32954514___ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Index_vue_vue_type_script_lang_js___ = __webpack_require__(896);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Index_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Index_vue_vue_type_template_id_32954514___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Index_vue_vue_type_template_id_32954514___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 896:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Index_vue_vue_type_script_lang_js___ = __webpack_require__(897);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Index_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 897:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_blocks_SiteHeader__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_blocks_SiteFooter__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_blocks_LeftBar__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_blocks_SmartphoneSiteMenu__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_SmartphoneFloatingBasket__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_GifAnimation__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexPage',
  data: function data() {
    return {
      smartphoneMenuOpened: false
    };
  },

  components: {
    SiteHeader: __WEBPACK_IMPORTED_MODULE_1__src_blocks_SiteHeader__["a" /* default */],
    SiteFooter: __WEBPACK_IMPORTED_MODULE_2__src_blocks_SiteFooter__["a" /* default */],
    LeftBar: __WEBPACK_IMPORTED_MODULE_3__src_blocks_LeftBar__["a" /* default */],
    SmartphoneSiteMenu: __WEBPACK_IMPORTED_MODULE_4__src_blocks_SmartphoneSiteMenu__["a" /* default */],
    SmartphoneFloatingBasket: __WEBPACK_IMPORTED_MODULE_5__src_components_SmartphoneFloatingBasket__["a" /* default */],
    GifAnimation: __WEBPACK_IMPORTED_MODULE_6__src_components_GifAnimation__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])({
    loadCategories: 'menu/loadCategories',
    loadPromotions: 'content/loadPromotions'
  }), {
    toggleSmartphoneMenu: function toggleSmartphoneMenu() {
      this.smartphoneMenuOpened = !this.smartphoneMenuOpened;
    }
  }),
  mounted: function mounted() {
    this.loadCategories();
    this.loadPromotions();
  }
});

/***/ }),

/***/ 898:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(899);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteHeader_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 899:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_SmartphoneSiteHeader__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_DesktopSiteHeader__ = __webpack_require__(929);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SiteHeader',
  props: {
    smartphoneMenuOpened: {
      type: Boolean,
      required: true
    }
  },
  components: {
    SmartphoneSiteHeader: __WEBPACK_IMPORTED_MODULE_0__src_components_SmartphoneSiteHeader__["a" /* default */],
    DesktopSiteHeader: __WEBPACK_IMPORTED_MODULE_1__src_components_DesktopSiteHeader__["a" /* default */]
  }
});

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-ru.c120ddc.svg";

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"13px\" viewBox=\"0 0 22 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Path</title><desc>Created with Sketch.</desc><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Footer\" transform=\"translate(-1326.000000, -44.000000)\" fill=\"#EB753F\" fill-rule=\"nonzero\"><g id=\"Group-3-Copy-2\"><path d=\"M1332.96552,59.1251764 L1332.96552,60.3251921 C1333.48755,60.3251921 1333.99282,60.1176687 1334.36624,59.7378797 L1342.43554,51.541005 C1343.18804,50.7753926 1343.18804,49.54917 1342.43621,48.7842358 L1334.36572,40.5861549 C1333.60461,39.8132344 1332.36055,39.803512 1331.58688,40.5640998 C1330.81279,41.3263777 1330.80347,42.5709757 1331.56494,43.3442469 L1338.27669,50.1622813 L1331.5648,56.9804613 C1330.80359,57.7547686 1330.81291,58.9988124 1331.58615,59.7602606 C1331.95875,60.1264832 1332.45432,60.3251921 1332.96552,60.3251921 L1332.96552,59.1251764 Z\" id=\"Path\" transform=\"translate(1337.000000, 50.162596) scale(1, -1) rotate(90.000000) translate(-1337.000000, -50.162596) \"></path></g></g></g></svg>"

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(903);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteHeader_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_Phone__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SmartphoneSiteHeader',
  components: {
    Phone: __WEBPACK_IMPORTED_MODULE_1__src_components_Phone__["a" /* default */]
  },
  props: {
    smartphoneMenuOpened: {
      type: Boolean,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    cart: 'cart/cart',
    totalSum: 'cart/totalSum',
    totalItems: 'cart/totalItems',
    currentFirstLevelCategory: 'menu/currentFirstLevelCategory',
    menuLoaded: 'menu/menuLoaded'
  }), {
    isMenuCategoryPage: function isMenuCategoryPage() {
      return this.$route.name === 'MenuCategory';
    },
    showPageNameInHeader: function showPageNameInHeader() {
      if (this.isMenuCategoryPage) {
        return this.menuLoaded;
      }
      return this.$route.name !== 'Index';
    },
    pageTitle: function pageTitle() {
      if (this.isMenuCategoryPage) {
        return this.currentFirstLevelCategory.title.rendered;
      }
      return this.$route.meta.headerTitle;
    }
  }),
  methods: {
    processHamburgerClick: function processHamburgerClick() {
      this.$emit('toggleSmartphoneMenu');
    },
    processClickBack: function processClickBack() {
      if (this.smartphoneMenuOpened) {
        this.$emit('toggleSmartphoneMenu');
      }
      this.$router.go(-1);
      // this.$router.push({ name: 'Index' })
    }
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

module.exports = "<svg width=\"18px\" height=\"13px\" viewBox=\"0 0 18 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>6G</title><desc>Created with Sketch.</desc><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"меню-copy\" transform=\"translate(-1269.000000, -30.000000)\" fill=\"#FFFFFF\"><g id=\"меню\"><g id=\"Group-17-Copy\" transform=\"translate(1260.000000, 16.000000)\"><g id=\"Group-6\"><path d=\"M15.9822005,24.602865 C16.6387382,24.602865 17.1728436,25.1417251 17.1728436,25.8034136 C17.1728436,26.4611399 16.6387382,27 15.9822005,27 C15.3256629,27 14.7915575,26.4611399 14.7915575,25.8034136 C14.7915575,25.1417251 15.3256629,24.602865 15.9822005,24.602865 Z M23.1629077,24.602865 C23.8194453,24.602865 24.3535507,25.1417251 24.3535507,25.8034136 C24.3535507,26.4611399 23.8194453,27 23.1629077,27 C22.50637,27 21.9722646,26.4611399 21.9722646,25.8034136 C21.9722646,25.1417251 22.50637,24.602865 23.1629077,24.602865 Z M23.944651,22.130448 L14.9833283,22.130448 L13.6647059,17.0905212 L25.102804,17.1024078 L23.944651,22.130448 Z M26.3144468,16.1395916 C26.2019201,15.9969521 26.031149,15.917708 25.8500762,15.9137458 L13.3532764,15.9018592 L12.9725084,14.4437671 C12.9039622,14.1822615 12.6678147,14 12.3975922,14 L9.594331,14 C9.26586407,14 9,14.2654678 9,14.594331 C9,14.9231941 9.26586407,15.188662 9.594331,15.188662 L11.9387687,15.188662 L12.316367,16.6309052 C12.3183481,16.6427918 12.3207254,16.6507162 12.3231027,16.6586407 L13.9491923,22.8753429 C14.0177385,23.1368485 14.253886,23.31911 14.5245047,23.31911 L24.4173423,23.31911 C24.6943005,23.31911 24.9344102,23.1289241 24.9966169,22.8594941 L26.4285584,16.6427918 C26.4693691,16.4684547 26.4273697,16.282231 26.3144468,16.1395916 L26.3144468,16.1395916 Z\" id=\"6G\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopSiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(906);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopSiteHeader_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_Phone__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_NarrowCart__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DesktopSiteHeader',
  components: {
    Phone: __WEBPACK_IMPORTED_MODULE_1__src_components_Phone__["a" /* default */],
    NarrowCart: __WEBPACK_IMPORTED_MODULE_2__src_components_NarrowCart__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    totalSum: 'cart/totalSum',
    totalItems: 'cart/totalItems'
  }), {
    isMenuPage: function isMenuPage() {
      return ['Index', 'MenuCategory'].includes(this.$route.name);
    }
  })
});

/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteFooter_vue_vue_type_script_lang_js___ = __webpack_require__(908);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteFooter_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_Phone__ = __webpack_require__(138);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SiteFooter',
  components: {
    Phone: __WEBPACK_IMPORTED_MODULE_0__src_components_Phone__["a" /* default */]
  },
  computed: {
    // isMenuPage () {
    //   return ['Index', 'MenuCategory'].includes(this.$route.name)
    // }
  }
});

/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_LeftBar_vue_vue_type_script_lang_js___ = __webpack_require__(910);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_LeftBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_blocks_DesktopCategories__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_blocks_ConditionsLeftBar__ = __webpack_require__(942);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeftBar',
  components: {
    DesktopCategories: __WEBPACK_IMPORTED_MODULE_0__src_blocks_DesktopCategories__["a" /* default */],
    ConditionsLeftBar: __WEBPACK_IMPORTED_MODULE_1__src_blocks_ConditionsLeftBar__["a" /* default */]
  }
});

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopCategories_vue_vue_type_script_lang_js___ = __webpack_require__(912);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopCategories_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DesktopCategories',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    categories: 'menu/categories'
  })),
  methods: {
    showSubcategories: function showSubcategories(category) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(category.children).length > 0 && this.$route.params.category === category.slug;
    }
  }
});

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConditionsLeftBar_vue_vue_type_script_lang_js___ = __webpack_require__(914);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConditionsLeftBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store_config_js__ = __webpack_require__(206);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConditionsLeftBar',
  data: function data() {
    return {
      zones: __WEBPACK_IMPORTED_MODULE_0__src_store_config_js__["a" /* deliveryZones */],
      activeZoneIndex: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('set-delivery-zone-clients_front', function (index) {
      _this.activeZoneIndex = index;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('set-delivery-zone-clients_front');
  },

  methods: {
    processMouseEnterZone: function processMouseEnterZone(index) {
      this.$bus.$emit('hover-delivery-zone-left-bar', index);
    },
    processMouseLeaveZone: function processMouseLeaveZone() {
      this.$bus.$emit('hover-delivery-zone-left-bar', null);
    }
  }
});

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteMenu_vue_vue_type_script_lang_js___ = __webpack_require__(916);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_blocks_SmartphoneCategories__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SmartphoneSiteMenu',
  components: {
    SmartphoneCategories: __WEBPACK_IMPORTED_MODULE_1__src_blocks_SmartphoneCategories__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    categories: 'menu/categories'
  }))
});

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneFloatingBasket_vue_vue_type_script_lang_js___ = __webpack_require__(918);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneFloatingBasket_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SmartphoneFloatingBasket',
  data: function data() {
    return {
      // expanded: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    totalSum: 'cart/totalSum',
    totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
    totalItems: 'cart/totalItems'
  }), {
    showBasket: function showBasket() {
      return this.totalItems > 0 && this.$route.name !== 'Order';
    }
  })
});

/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GifAnimation_vue_vue_type_script_lang_js___ = __webpack_require__(920);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GifAnimation_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GifAnimation',
  data: function data() {
    return {
      animationKey: 'hidedsv',
      hideAnimation: false
    };
  },

  computed: {
    gifUrl: function gifUrl() {
      if (true) {
        return '/wp-content/themes/welbempty/vue/static/dsv.gif';
      } else {
        return '/static/dsv.gif';
      }
    }
  },
  methods: {
    hide: function hide() {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hidedsv', 'true', { expires: 2 });
      this.hideAnimation = true;
    }
  },
  mounted: function mounted() {
    this.hideAnimation = Boolean(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('hidedsv'));
  }
});

/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Index_vue_vue_type_template_id_32954514___ = __webpack_require__(922);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Index_vue_vue_type_template_id_32954514___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Index_vue_vue_type_template_id_32954514___["b"]; });


/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('site-header',{attrs:{"smartphoneMenuOpened":_vm.smartphoneMenuOpened},on:{"toggleSmartphoneMenu":_vm.toggleSmartphoneMenu}}),_vm._v(" "),_c('transition',{attrs:{"name":"smartphone-menu"}},[(_vm.isSmartphone && _vm.smartphoneMenuOpened)?_c('smartphone-site-menu',{on:{"clickLink":_vm.toggleSmartphoneMenu}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{ 'has-left-bar': _vm.pageHasLeftBar },attrs:{"id":"main-layout-flex"}},[(!_vm.isSmartphone)?_c('left-bar'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"right-content"}},[_c('router-view',{staticClass:"router-view-content"}),_vm._v(" "),_c('site-footer')],1)],1),_vm._v(" "),(_vm.isSmartphone)?_c('smartphone-floating-basket'):_vm._e()],1)}
var staticRenderFns = []



/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SiteHeader_vue_vue_type_template_id_dc7fe0cc___ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(898);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SiteHeader_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SiteHeader_vue_vue_type_template_id_dc7fe0cc___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SiteHeader_vue_vue_type_template_id_dc7fe0cc___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteHeader_vue_vue_type_template_id_dc7fe0cc___ = __webpack_require__(925);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteHeader_vue_vue_type_template_id_dc7fe0cc___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteHeader_vue_vue_type_template_id_dc7fe0cc___["b"]; });


/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-header"}},[(_vm.isSmartphone)?_c('smartphone-site-header',{attrs:{"smartphoneMenuOpened":_vm.smartphoneMenuOpened},on:{"toggleSmartphoneMenu":function($event){return _vm.$emit('toggleSmartphoneMenu')}}}):_c('desktop-site-header')],1)}
var staticRenderFns = []



/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteHeader_vue_vue_type_template_id_738df693___ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmartphoneSiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SmartphoneSiteHeader_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteHeader_vue_vue_type_template_id_738df693___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteHeader_vue_vue_type_template_id_738df693___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteHeader_vue_vue_type_template_id_738df693___ = __webpack_require__(928);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteHeader_vue_vue_type_template_id_738df693___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteHeader_vue_vue_type_template_id_738df693___["b"]; });


/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-header"}},[_c('div',{staticClass:"landing-width-container"},[(!_vm.showPageNameInHeader)?[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'Index' }}},[_c('img',{attrs:{"src":__webpack_require__(900)}})]),_vm._v(" "),_c('div',{staticClass:"phone-cont"},[_c('phone'),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Звонок бесплатный")])],1)]:[_c('div',{staticClass:"back-button",on:{"click":_vm.processClickBack}},[_c('svg-inline',{attrs:{"src":__webpack_require__(901)}})],1),_vm._v(" "),_c('div',{staticClass:"page-title"},[(_vm.isMenuCategoryPage)?_c('img',{staticClass:"icon",attrs:{"src":_vm.currentFirstLevelCategory.acf.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pageTitle))])])],_vm._v(" "),_c('div',{staticClass:"hamburger hamburger--spin",class:{ 'is-active': _vm.smartphoneMenuOpened },on:{"click":_vm.processHamburgerClick}},[_vm._m(0)])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])}]



/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DesktopSiteHeader_vue_vue_type_script_lang_js___ = __webpack_require__(905);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DesktopSiteHeader_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___ = __webpack_require__(931);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopSiteHeader_vue_vue_type_template_id_92bfd5a4___["b"]; });


/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-width-container"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'Index' }}},[_c('img',{attrs:{"src":__webpack_require__(900)}})]),_vm._v(" "),_c('div',{staticClass:"phone-cont"},[_c('phone'),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Звонок бесплатный")])],1),_vm._v(" "),_c('div',{staticClass:"site-menu-links"},[_c('router-link',{class:{ 'active': _vm.isMenuPage },attrs:{"to":{ name: 'Index' }}},[_c('div',{staticClass:"visible"},[_vm._v("Меню")]),_c('div',{staticClass:"back"},[_vm._v("Меню")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Conditions' },"active-class":"active"}},[_c('div',{staticClass:"visible"},[_vm._v("Доставка и оплата")]),_c('div',{staticClass:"back"},[_vm._v("Доставка и оплата")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Restaurants' },"active-class":"active"}},[_c('div',{staticClass:"visible"},[_vm._v("Рестораны")]),_c('div',{staticClass:"back"},[_vm._v("Рестораны")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"header-cart",class:{ 'empty': _vm.totalItems === 0, 'order-page': _vm.$route.name === 'Order' }},[_c('router-link',{staticClass:"info-container",attrs:{"to":{ name: 'Order' }}},[_c('svg-inline',{staticClass:"header-cart-icon",attrs:{"src":__webpack_require__(904)}}),_vm._v(" "),_c('div',{staticClass:"ver-line"}),_vm._v(" "),(_vm.totalItems > 0)?[_c('div',{staticClass:"total"},[_vm._v(" "+_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1),_vm._v(" "),_c('div',{staticClass:"ver-line"}),_vm._v(" "),_c('div',{staticClass:"lines"},[_vm._v(_vm._s(_vm.totalItems))])]:_c('div',{staticClass:"lines"},[_vm._v("Корзина пуста")])],2),_vm._v(" "),_c('div',{staticClass:"overlay-cart-container"},[_c('div',{staticClass:"overlay-cart"},[_c('narrow-cart'),_vm._v(" "),_c('router-link',{staticClass:"red button",class:{ 'disabled': _vm.totalSum < 800 },attrs:{"to":{ name: 'Order' }}},[_vm._v("Оформить заказ")])],1)])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-info"},[_c('b',{staticStyle:{"font-size":"0.7em"}},[_vm._v("Санкт-Петербург:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"addresses"},[_vm._v("Ул Оптиков 51/1,"),_c('br'),_vm._v("Ул Достоевского 6,"),_c('br'),_vm._v("Наб Реки Фонтанки 92")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-info"},[_c('span',{staticClass:"label"},[_vm._v("Доставляем еду")]),_c('br'),_vm._v("\n      с 10:00 до 2:00\n    ")])}]



/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SiteFooter_vue_vue_type_template_id_cf15022c___ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SiteFooter_vue_vue_type_script_lang_js___ = __webpack_require__(907);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SiteFooter_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SiteFooter_vue_vue_type_template_id_cf15022c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SiteFooter_vue_vue_type_template_id_cf15022c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteFooter_vue_vue_type_template_id_cf15022c___ = __webpack_require__(934);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteFooter_vue_vue_type_template_id_cf15022c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SiteFooter_vue_vue_type_template_id_cf15022c___["b"]; });


/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-footer"}},[_c('div',{staticClass:"adaptive-column-content"},[_c('div',{staticClass:"top-line"},[_c('div',{staticClass:"logo-descriptor"},[_c('img',{attrs:{"src":__webpack_require__(935)}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"main-links"},[_c('router-link',{attrs:{"to":{ name: 'Index' }}},[_vm._v("Меню")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Conditions' }}},[_vm._v("Доставка и оплата")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Restaurants' }}},[_vm._v("Рестораны")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"block-with-title"},[_c('div',{staticClass:"title"},[_vm._v("Звоните")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('phone')],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('router-link',{directives:[{name:"mg-smooth-scroll",rawName:"v-mg-smooth-scroll",value:({ autoDetectOffsetByTopBar: true }),expression:"{ autoDetectOffsetByTopBar: true }"}],staticClass:"returner",attrs:{"to":{ hash: '#main-layout-flex' }}},[_c('svg-inline',{attrs:{"src":__webpack_require__(901)}})],1)],1),_vm._v(" "),_c('div',{staticClass:"separator-line"}),_vm._v(" "),(_vm.isSmartphone)?_c('div',{staticClass:"middle-line"},[_c('div',{staticClass:"block-with-title"},[_c('div',{staticClass:"title"},[_vm._v("Звоните")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('phone')],1)]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_vm._m(4)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptor"},[_vm._v("Восточная"),_c('br'),_vm._v("домашняя кухня")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-with-title"},[_c('div',{staticClass:"title"},[_vm._v("Адреса")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n            Санкт-Петербург:"),_c('br'),_vm._v("\n            Ул Оптиков 51/1,"),_c('br'),_vm._v("\n            Ул Достоевского 6,"),_c('br'),_vm._v("\n            Наб Реки Фонтанки 92\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-with-title last"},[_c('div',{staticClass:"title"},[_vm._v("Часы работы")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("с 10:00 до 2:00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-with-title last"},[_c('div',{staticClass:"title"},[_vm._v("Часы работы")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("с 10:00 до 2:00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-line"},[_c('div',{staticClass:"copyright"},[_vm._v("\n          Copyright ©Mangal Grill\n        ")])])}]



/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-white.797537b.svg";

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftBar_vue_vue_type_template_id_636bef62___ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar_vue_vue_type_script_lang_js___ = __webpack_require__(909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__LeftBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__LeftBar_vue_vue_type_template_id_636bef62___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__LeftBar_vue_vue_type_template_id_636bef62___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 937:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LeftBar_vue_vue_type_template_id_636bef62___ = __webpack_require__(938);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LeftBar_vue_vue_type_template_id_636bef62___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LeftBar_vue_vue_type_template_id_636bef62___["b"]; });


/***/ }),

/***/ 938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageHasLeftBar)?_c('div',{attrs:{"id":"left-bar"}},[_c('div',{staticClass:"adaptive-column-content"},[_c(this.$route.meta.leftBarComponent,{tag:"component"})],1)]):_vm._e()}
var staticRenderFns = []



/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DesktopCategories_vue_vue_type_template_id_b670d08e___ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DesktopCategories_vue_vue_type_script_lang_js___ = __webpack_require__(911);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DesktopCategories_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DesktopCategories_vue_vue_type_template_id_b670d08e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DesktopCategories_vue_vue_type_template_id_b670d08e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopCategories_vue_vue_type_template_id_b670d08e___ = __webpack_require__(941);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopCategories_vue_vue_type_template_id_b670d08e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DesktopCategories_vue_vue_type_template_id_b670d08e___["b"]; });


/***/ }),

/***/ 941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop-categories"},[_vm._l((_vm.categories),function(category){return [_c('router-link',{key:category.id,class:{ 'has-children': Object.keys(category.children).length > 0 },attrs:{"to":{ name: 'MenuCategory', params: { category: category.slug } },"active-class":"active","exact-active-class":"leaf-active"}},[_c('img',{staticClass:"icon",attrs:{"src":category.acf.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(category.title.rendered))])]),_vm._v(" "),(Object.keys(category.children).length > 0)?_c('div',{staticClass:"subcategories",class:{ 'expanded': _vm.showSubcategories(category) },style:({ maxHeight: _vm.showSubcategories(category) ? (Object.values(category.children).length * 0.5 + 'em') : null })},_vm._l((category.children),function(subcategory){return _c('router-link',{key:subcategory.id,attrs:{"to":{ name: 'MenuCategory', params: { category: category.slug, subcategory: subcategory.slug } },"active-class":"active"}},[_c('div',{staticClass:"dot"}),_c('span',[_vm._v(_vm._s(subcategory.title.rendered))])])}),1):_vm._e()]})],2)}
var staticRenderFns = []



/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConditionsLeftBar_vue_vue_type_script_lang_js___ = __webpack_require__(913);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConditionsLeftBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___ = __webpack_require__(944);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConditionsLeftBar_vue_vue_type_template_id_4906dfe0___["b"]; });


/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conditions-left-bar"},[_vm._l((_vm.zones),function(zone,index){return _c('div',{key:index,staticClass:"zone",class:{ 'active': index === _vm.activeZoneIndex },on:{"mouseenter":function($event){return _vm.processMouseEnterZone(index)},"mouseleave":function($event){return _vm.processMouseLeaveZone()}}},[_c('div',{staticClass:"marker",style:({ backgroundColor: zone.color })}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v("Зона доставки "+_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Минимальный заказ "+_vm._s(zone.minSum)+" "),_c('rub')],1)])])}),_vm._v(" "),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_vm._v("\n    Время доставки заказа: от 1 часа"),_c('br'),_c('br'),_vm._v("\n    *Время доставки может изменяться в связи с дорожной ситуацией\n  ")])}]



/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmartphoneSiteMenu_vue_vue_type_script_lang_js___ = __webpack_require__(915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SmartphoneSiteMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___ = __webpack_require__(947);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneSiteMenu_vue_vue_type_template_id_1e0c5ff5___["b"]; });


/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smartphone-site-menu"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"site-link",attrs:{"to":{ name: 'Conditions' },"active-class":"active"},nativeOn:{"click":function($event){return _vm.$emit('clickLink')}}},[_vm._v("Доставка и оплата")]),_vm._v(" "),_c('router-link',{staticClass:"site-link",attrs:{"to":{ name: 'Restaurants' },"active-class":"active"},nativeOn:{"click":function($event){return _vm.$emit('clickLink')}}},[_vm._v("Рестораны")]),_vm._v(" "),_c('router-link',{staticClass:"site-link",attrs:{"to":{ name: 'Index' },"active-class":"active"},nativeOn:{"click":function($event){return _vm.$emit('clickLink')}}},[_vm._v("Меню")]),_vm._v(" "),_c('smartphone-categories',{attrs:{"hideTitle":true},on:{"clickCategory":function($event){return _vm.$emit('clickLink')},"clickLink":function($event){return _vm.$emit('clickLink')}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-line"},[_c('div',{staticClass:"address-info"},[_c('b',[_vm._v("Санкт-Петербург:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"addresses"},[_vm._v("Ул Оптиков 51/1,"),_c('br'),_vm._v("Ул Достоевского 6,"),_c('br'),_vm._v("Наб Реки Фонтанки 92")])]),_vm._v(" "),_c('div',{staticClass:"time-info"},[_c('span',{staticClass:"label"},[_vm._v("Доставляем еду")]),_c('br'),_vm._v("\n        с 10:00 до 2:00\n      ")])])}]



/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmartphoneFloatingBasket_vue_vue_type_script_lang_js___ = __webpack_require__(917);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SmartphoneFloatingBasket_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___ = __webpack_require__(950);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneFloatingBasket_vue_vue_type_template_id_c3c23c7a___["b"]; });


/***/ }),

/***/ 950:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBasket)?_c('router-link',{staticClass:"smartphone-floating-basket",attrs:{"to":{ name: 'Order' }}},[_c('div',{staticClass:"icon"},[_c('svg-inline',{attrs:{"src":__webpack_require__(904)}})],1),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Корзина")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1),_vm._v(" "),(_vm.totalSumBeforeDiscount !== _vm.totalSum)?_c('div',{staticClass:"crossed-total"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSumBeforeDiscount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ver-line"}),_vm._v(" "),_c('div',{staticClass:"lines"},[_vm._v(_vm._s(_vm.totalItems))])]):_vm._e()}
var staticRenderFns = []



/***/ }),

/***/ 951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GifAnimation_vue_vue_type_template_id_56cd47d8___ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GifAnimation_vue_vue_type_script_lang_js___ = __webpack_require__(919);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GifAnimation_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GifAnimation_vue_vue_type_template_id_56cd47d8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GifAnimation_vue_vue_type_template_id_56cd47d8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GifAnimation_vue_vue_type_template_id_56cd47d8___ = __webpack_require__(953);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GifAnimation_vue_vue_type_template_id_56cd47d8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GifAnimation_vue_vue_type_template_id_56cd47d8___["b"]; });


/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideAnimation)?_c('div',{attrs:{"id":"gifan"}},[_c('img',{staticClass:"cross",attrs:{"src":__webpack_require__(954)},on:{"click":_vm.hide}}),_vm._v(" "),_c('img',{staticClass:"main",attrs:{"src":_vm.gifUrl}})]):_vm._e()}
var staticRenderFns = []



/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/nycross.d5162d6.svg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.3987c911690ade2111a9.bundle.js